import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { pdfjs } from "react-pdf";

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
    "pdfjs-dist/build/pdf.worker.min.js",
    import.meta.url
).toString();

const PdfViewerComponent = ({ width, height, zoom = 1, pageNumber, setPageNumber, pdfUrl }) => {
    const [pagesData, setPagesData] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const loadPdf = async () => {
            if (!pdfUrl) return;

            setLoading(true);

            const pdf = await pdfjs.getDocument(pdfUrl).promise;
            const tempPages = [];

            for (let i = 1; i <= pdf.numPages; i++) {
                const page = await pdf.getPage(i);
                const viewport = page.getViewport({ scale: zoom });
                const canvas = document.createElement("canvas");
                canvas.width = viewport.width;
                canvas.height = viewport.height;
                const context = canvas.getContext("2d");

                await page.render({ canvasContext: context, viewport }).promise;

                tempPages.push({ pageNumber: i, src: canvas.toDataURL() });
            }

            setPagesData(tempPages);
            setLoading(false);
        };

        loadPdf();
    }, [pdfUrl, zoom]);

    if (loading) return (
        <div
            style={{
                width,
                height,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                border: "1px solid #ccc",
                backgroundColor: "#f8f8f8",
                fontSize: 16,
                fontWeight: "bold",
            }}
        >
            Loading PDF ...
        </div>
    );

    const currentPage = pagesData[pageNumber - 1];

    return (
        <div
            style={{
                width,
                height,
                overflow: "hidden",
                border: "1px solid #ccc",
                backgroundColor: "#f8f8f8",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
            }}
        >
            {currentPage && (
                <img
                    src={currentPage.src}
                    alt={`Page ${currentPage.pageNumber}`}
                    width={width}
                    style={{ display: "block" }}
                />
            )}
        </div>
    );
};

PdfViewerComponent.propTypes = {
    width: PropTypes.number,
    height: PropTypes.number,
    zoom: PropTypes.number,
    pageNumber: PropTypes.number,
    setPageNumber: PropTypes.func,
    pdfUrl: PropTypes.string,
};

export default PdfViewerComponent;
